
<div class="card-multipliers">
  <div
    v-for="(multiplier, i) in multipliers"
    :key="i"
    class="multiplier"
  >
    <div class="card-search-container">
      <template v-if="multipliers[i].card">
        <card-list-item
          :card="multipliers[i]"
          :fields="['currentValue']"
          :custom-fields="[{
            label: 'Multiplier',
            value: `${$filters.decimal(multipliers[i].value)}x`,
          }]"
        />

        <div v-if="multipliers[i].results" class="results">
          <span>{{ multipliers[i].results }}</span>
        </div>
      </template>

      <card-search
        v-else
        placeholder="Search for a card"
        @select="setMultiplier(i, $event)"
      />
    </div>

    <align v-show="multipliers[i].card" flex>
      <text-input
        v-model="multipliers[i].value"
        type="decimal"
        label="Multplier ratio"
      />

      <btn class="remove" kind="secondary" @click="removeMultiplier(i)">
        {{ removeText }}
      </btn>
    </align>
  </div>

  <add-link
    v-if="multipliers && multipliers.length < limit && hasCompleteMultiplier"
    class="icon-link"
    @click="addMultiplier"
  >
    Add another multiplier
  </add-link>

  <div v-show="estimatedValue && hasCompleteMultiplier" class="estimated-value">
    <span>Estimated Value:</span> <b>{{ $filters.currency(estimatedValue, { full: true }) }}</b>
  </div>
</div>
